var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.address.primary
      ? _c("div", { staticClass: "address__primary" }, [
          _vm._v(_vm._s(_vm.strings["address_primary"]))
        ])
      : _c(
          "div",
          {
            staticClass: "address__button address__button--primary",
            on: {
              click: function($event) {
                return _vm.$emit("set-primary", _vm.address.id)
              }
            }
          },
          [_vm._v(_vm._s(_vm.strings["address_set_primary"]))]
        ),
    _vm._v(" "),
    _c("div", { staticClass: "address__body" }, [
      _c("b", [
        _vm._v(_vm._s(_vm.address.name) + " " + _vm._s(_vm.address.surname))
      ]),
      _c("br"),
      _vm._v(" "),
      _vm.address.company_name || _vm.address.companyName
        ? _c("span", [
            _vm._v(
              "\n            " +
                _vm._s(_vm.address.company_name || _vm.address.companyName)
            ),
            _c("br")
          ])
        : _vm._e(),
      _vm._v("\n        " + _vm._s(_vm.address.address)),
      _c("br"),
      _vm._v(
        "\n        " +
          _vm._s(_vm.address.city) +
          ", " +
          _vm._s(_vm.address.zip_code) +
          " " +
          _vm._s(_vm.address.district)
      ),
      _c("br"),
      _vm._v(" "),
      _c("div", { staticClass: "pv2" }, [_vm._v(_vm._s(_vm.address.telephone))])
    ]),
    _vm._v(" "),
    _c("hr"),
    _vm._v(" "),
    _c("div", { staticClass: "flex items-center justify-between" }, [
      _c(
        "div",
        {
          staticClass: "address__button address__button--change",
          on: {
            click: function($event) {
              return _vm.$emit("load-address", _vm.address.id)
            }
          }
        },
        [_vm._v(_vm._s(_vm.strings["address_modify"]))]
      ),
      _vm._v(" "),
      _vm.disabled === false
        ? _c(
            "div",
            {
              staticClass: "address__button address__button--remove",
              on: {
                click: function($event) {
                  return _vm.$emit("remove-address", _vm.address.id)
                }
              }
            },
            [_vm._v(_vm._s(_vm.strings["address_delete"]))]
          )
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }